import { axiosInstance } from "@/utils/lib/axios";

export default async function waitForMediaCompletion(
  url: string,
  interval = 2000,
  maxAttempts = 150,
): Promise<
  | {
      success: true;
      path: string;
      originalFileName: string;
    }
  | {
      success: false;
      error: string;
    }
> {
  let attempts = 0;

  while (attempts < maxAttempts) {
    const {
      data: {
        data: { status, path, originalFileName, error },
      },
    } = await axiosInstance.get(`${url}`);

    if (status === "SUCCESS") {
      return {
        success: true,
        path: path!,
        originalFileName: originalFileName ?? "downloaded-file.xlsx",
      };
    }

    if (status === "ERROR" || status === "FAILED") {
      return {
        success: false,
        error: error ?? "Media processing failed",
      };
    }

    attempts++;
    await new Promise((resolve) => setTimeout(resolve, interval));
  }

  return {
    success: false,
    error: "Export timeout",
  };
}
